import React, { useState, useEffect } from 'react';
import { List, Avatar, Typography, Spin, Empty, Tag } from 'antd';
import { UserOutlined, PhoneOutlined, MailOutlined } from '@ant-design/icons';
import { fetchUsersByBranch } from '../api';

const { Text, Title } = Typography;

const BranchUsers = ({ branchId, branchName }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (branchId) {
      loadBranchUsers();
    }
  }, [branchId]);

  const loadBranchUsers = async () => {
    setLoading(true);
    try {
      const response = await fetchUsersByBranch(branchId);
      setUsers(response.data || []);
    } catch (error) {
      console.error('Error loading branch users:', error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '20px 0' }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>Loading branch users...</div>
      </div>
    );
  }

  if (users.length === 0) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <span>
            No users assigned to <Text strong>{branchName}</Text>
          </span>
        }
      />
    );
  }

  return (
    <div>
      <Title level={5} style={{ marginBottom: 16 }}>
        Users Assigned to {branchName} ({users.length})
      </Title>
      
      <List
        itemLayout="horizontal"
        dataSource={users}
        renderItem={(user) => (
          <List.Item
            actions={[
              user.phone && (
                <Text type="secondary" key="phone">
                  <PhoneOutlined /> {user.phone}
                </Text>
              ),
              user.email && (
                <Text type="secondary" key="email">
                  <MailOutlined /> {user.email}
                </Text>
              )
            ].filter(Boolean)}
          >
            <List.Item.Meta
              avatar={
                <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1890ff' }} />
              }
              title={
                <div>
                  <Text strong>{user.name}</Text>
                  {user.designation && (
                    <Tag color="blue" style={{ marginLeft: 8 }}>
                      {user.designation}
                    </Tag>
                  )}
                </div>
              }
              description={user.email}
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default BranchUsers;
